import { createContext, useContext, useState, ReactNode } from 'react'

type VideoRecordingContextType = {
  isRecording: boolean
  setIsRecording: (status: boolean) => void
  isWaiting: boolean
  setIsWaiting: (status: boolean) => void
}

const VideoRecordingContext = createContext<
  VideoRecordingContextType | undefined
>(undefined)

export const VideoRecordingProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const [isRecording, setIsRecording] = useState(false)
  const [isWaiting, setIsWaiting] = useState(false)

  return (
    <VideoRecordingContext.Provider
      value={{ isRecording, setIsRecording, isWaiting, setIsWaiting }}
    >
      {children}
    </VideoRecordingContext.Provider>
  )
}

export const useVideoRecording = () => {
  const context = useContext(VideoRecordingContext)
  if (!context) {
    throw new Error(
      'useVideoRecording must be used within a VideoRecordingProvider'
    )
  }
  return context
}
